import {combineReducers, Reducer} from '@reduxjs/toolkit'

import {routerReducer} from '@web/slices/router'

import {RootState} from '../interfaces'
import common from '../slices/common'
import deliveryManager from '../slices/deliveryManager'

const createRootReducer = (): Reducer<RootState> =>
    combineReducers({
        common,
        deliveryManager,
        router: routerReducer,
    })

export default createRootReducer
